import React, { useState } from 'react';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';


import './home.css';
import Loading from '../components/Loading';
import AlertError from '../components/AlertError';
import { ValidarEmail } from '../../utils/ValidarEmail';
import { MascaraTelefone } from '../../utils/MascaraTelefone';
import { GerarToken } from '../../utils/GerarToken';
import axios from 'axios';

const inputStyles = {
    "& .MuiInputBase-input": { color: "white" },
    "& .MuiInputLabel-root": { color: "white", },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1EFF86" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1EFF86" },
};

const Home = () => {

    const [nome, setNome] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [email, setEmail] = useState('');
    const [areaTrabalho, setAreaTrabalho] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorOpen, setErrorOpen] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(localStorage.getItem('formToken') ? true : false);
    const [token, setToken] = useState(localStorage.getItem('formToken') || '');

    const handleChange = (event) => {
        setAreaTrabalho(event.target.value);
    };


    const handleSubmit = async () => {

        if (!nome || !whatsapp || !email || !areaTrabalho) {
            setMensagem("Por favor, preencha todos os campos.");
            setErrorOpen(true);
            return;
        }

        if (!ValidarEmail(email)) {
            setMensagem("Por favor, insira um e-mail válido.");
            setErrorOpen(true);
            return;
        }

        setLoading(true);

        let token = GerarToken();
        setToken(token);


        try {
            let body = {
                nome: nome,
                telefone: whatsapp.replaceAll(/\D/g, ''),
                email: email,
                areaTrabalho: areaTrabalho,
                formToken: token
            }

            const response = await axios.post('https://api.contblack.com.br/api/submitForm', body);
            if (response.status === 200) {
                localStorage.setItem('formToken', token);
                setLoading(false);
                setFormSubmitted(true);
                console.log("Formulário enviado com sucesso");
            } else {
                setMensagem("Ocorreu um erro ao enviar o formulário. Tente novamente mais tarde.");
                setErrorOpen(true);
                setLoading(false);
                return;
            }
        } catch (error) {
            console.error("Erro ao enviar o formulário:", error.response.data.mensagem);
            setMensagem(error.response.data.mensagem);
            setErrorOpen(true);
            setLoading(false);
            return;
        }

    }


    return (

        formSubmitted ? (
            <div className="divGlobal">
                <div className='divForm'>
                    <div className='divLogo'>
                        <img src="./assets/Logo_Contblack_FundoEscuro.png" alt="" />
                    </div >
                    <div className='divTexto sucesso'>
                        <h3>SUCESSO!</h3>
                        <p>Formulário enviado.</p>
                        <p>Referência no mercado digital, a Contblack agradece sua participação. Mostre esta mensagem e retire seu PRÊMIO!</p>
                    </div>
                    <div className='divider' />
                    <div className='divTexto sucesso'>
                        <p>TOKEN CONFIRMAÇÂO DE ENVIO DO FORMULÁRIO</p>
                        <h3>{token}</h3>
                    </div>
                </div >
            </div >
        ) : (
            <div className="divGlobal">
                <div className='divForm'>
                    <div className='divLogo'>
                        <img src="./assets/Logo_Contblack_FundoEscuro.png" alt="" />
                    </div >
                    <div className='divTexto'>
                        <h3>Bem-vindo ao ContBlack</h3>
                        <p>Aproveite a oportunidade de conhecer uma marca que já trabalha com grandes nomes do mercado. Preencha o formulário e libere seu PRÊMIO.</p>
                    </div>

                    <div className='divInputs'>
                        <TextField
                            autoComplete='off'
                            label="Nome"
                            placeholder="Digite seu nome"
                            fullWidth
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            variant="outlined"
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <AccountCircle sx={{ color: "white" }} />
                                    </InputAdornment>
                                }
                            }}
                            sx={inputStyles}
                        />
                        <TextField
                            autoComplete='off'
                            label="Seu WhatsApp"
                            placeholder="Digite seu WhatsApp"
                            fullWidth
                            value={whatsapp}
                            onChange={(e) => setWhatsapp(MascaraTelefone(e.target.value))}
                            variant="outlined"
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <WhatsAppIcon sx={{ color: "white" }} />
                                    </InputAdornment>
                                }
                            }}
                            sx={inputStyles}
                        />

                        <TextField
                            autoComplete='off'
                            label="E-mail"
                            placeholder="Digite seu e-mail"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            variant="outlined"
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <EmailIcon sx={{ color: "white" }} />
                                    </InputAdornment>
                                }
                            }}
                            sx={inputStyles}
                        />
                        <FormControl fullWidth sx={inputStyles}>

                            <InputLabel id="demo-simple-select-label">Área de trabalho</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={areaTrabalho}
                                label="Área de trabalho"
                                onChange={handleChange}
                                sx={inputStyles}
                            >
                                <MenuItem value={"Empregado CLT"}>Empregado CLT</MenuItem>
                                <MenuItem value={"Influenciador(a) Digital"}>Influenciador(a) Digital</MenuItem>
                                <MenuItem value={"Criador(a) de Conteúdo +18"}>Criador(a) de Conteúdo +18</MenuItem>
                                <MenuItem value={"Streamer/Youtuber"}>Streamer / Youtuber</MenuItem>
                                <MenuItem value={"Desenvolvedor(a) de Software"}>Desenvolvedor(a) de Software</MenuItem>
                                <MenuItem value={"Designer Gráfico/Web Designer"}>Designer Gráfico / Web Designer</MenuItem>
                                <MenuItem value={"Outra Profissão"}>Outra Profissão</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className='divButton'>
                        <Button
                            variant="contained"
                            disabled={loading}
                            sx={{
                                width: "100%",
                                backgroundColor: "#1EFF86",
                                borderRadius: "17px 0 17px 0",
                                fontSize: "0.9rem",
                                fontWeight: 800,
                                py: 1.2,
                                color: "#000",
                                transition: "0.3s",
                                '&:hover': {
                                    backgroundColor: "#9C01B9",
                                    boxShadow: "0 4px 12px #9C01B9",
                                }
                            }}
                            onClick={handleSubmit}
                        >
                            Enviar
                        </Button>
                    </div>
                </div >
                <Loading open={loading} />
                <AlertError open={errorOpen} setOpen={setErrorOpen} mensagem={mensagem} />
            </div >

        )
    );
}

export default Home;